import axiosInstance from './axiosInstance';

const parseJsonArray = (value) => {
  if (Array.isArray(value)) return value;
  if (!value) return [];
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return value.split('\n').map((s) => s.trim()).filter(Boolean);
    }
  }
  return [];
};

export const mapAboutMission = (row) => {
  if (!row || !row.title) return null;
  return {
    label: row.label ?? 'Our Mission',
    title: row.title ?? '',
    subtitle: row.subtitle ?? '',
    bodyParagraphs: parseJsonArray(row.body_paragraphs ?? row.bodyParagraphs),
    listItems: parseJsonArray(row.list_items ?? row.listItems),
    quoteText: row.quote_text ?? row.quoteText ?? '',
    quoteAuthor: row.quote_author ?? row.quoteAuthor ?? '',
    imagePath: row.image_path ?? row.imagePath ?? '',
    isActive: Boolean(row.is_active ?? row.isActive ?? true),
  };
};

export const fetchAboutMission = async () => {
  const response = await axiosInstance.get('/about/mission');
  return mapAboutMission(response.data);
};

export const updateAboutMission = async (payload) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null || key === 'file') return;
    formData.append(key, value);
  });
  if (payload.file) formData.append('missionImage', payload.file);

  const response = await axiosInstance.put('/about/mission', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
